export class HtmlHelper {
	static HtmlBreak(value: string): string {
		return value
			.replace(/</g, '')
			.replace(/&lt;/g, '');
	}
}